<template>
  <div class="bottom-sheet">
    <vue-bottom-sheet-vue2 ref="bottomSheet" overlay-color="#00000080" @closed="closed" @opened="opened" @dragging-up="draggUp" @dragging-down="draggDown"> 
      <div class="head-wrap">
        <div class="head">{{ title }}</div>
        <i v-if="showClose" @click="btnClose"></i>
      </div>
      <div @touchstart.stop @touchmove.stop>
        <slot></slot>
      </div>
      <slot name="footer"></slot>
    </vue-bottom-sheet-vue2>
  </div>
</template>

<script>
import  VueBottomSheetVue2 from "@webzlodimir/vue-bottom-sheet-vue2";
export default {
  props: {
    scrollElId: {
      type: String,
      default: 'app-warp'
    },
    title: {
      type: String,
      default: ""
    },
    showClose: {
      type: Boolean,
      default: false
    },
  },
  components: {
    VueBottomSheetVue2
  },
  methods: {
    open() {
      this.$refs.bottomSheet.open();
      document.getElementById(this.scrollElId) && (document.getElementById(this.scrollElId).style.overflow = 'hidden')
    },
    close() {
      this.$refs.bottomSheet.close();
    },
    btnClose(){
      this.$refs.bottomSheet.close();
      this.$emit('closed')
    },
    closed() {
      this.$emit('closed')
      document.getElementById(this.scrollElId) && (document.getElementById(this.scrollElId).style.overflow = '')
    },
    opened() {
      this.$emit('opened')
    },
    draggUp(){
      this.$emit('dragging-up')
    },
    draggDown(){
      this.$emit('dragging-down')
    }
  }
}
</script>

<style scoped lang="scss">
.bottom-sheet{
  :deep(.bottom-sheet__content){
    background: #f5f5f5;
  }
  :deep(.bottom-sheet__draggable-area){
    padding: .16rem 0 .24rem;
  }
  :deep(.bottom-sheet__draggable-thumb){
    width: .64rem;
    height: .08rem;
    border-radius: 1rem;
    background: #E5E5E5 !important;
  }
  :deep(.bottom-sheet__main){
    overflow-y: auto !important;
    height: 100% !important;
    -webkit-overflow-scrolling: touch; 
  }
}

.head-wrap{
  position: relative;
  i{
    position: absolute;
    right: .32rem;
    top: 0;
    width: .4rem;
    height: .4rem;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAACXBIWXMAACE4AAAhOAFFljFgAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAINSURBVHgB7ZrBTcMwFIYduFQ90U5AN+iREdiCcuPYK1MgJqBsABuwAhOwQdNb4RTeX6VSGprUz37vhUrvk6ImTmLni63Uz3YIjuM4juM4zj/hqiYMTOpzXHAupvyXRVF80VbS/lMYiOl0+oJnqJ9jybm3iL0QbxMFHNxcFKv1en0fDIFsVVWLRtKGjmcbIuZ+Vg23QcF4gGDEEVnAatbRwniDVKOv7XQr6Q5ZlP8cW7vgMjDYbrdv4/F4Rrvz1qk5pV/T+fegQJcsKqAsy4fAgCUMrKX7ZOn7sQhM2MLASlpaFiQJA21pDVmQLAy0pLVkQZYwkJbWlAXZwkBKWlsWiAiDXGkLWSAmDFKlrWSBqDDgSlvKAnFhECttLbvLOyhCQisSumunI8rCr7XsLv+gTJf0MbRlgUqTbtLTvA+wkAXqwuCUtJUsyBoAYFIlnhPFpIa7vsYNVOPpJurCEbJ7TKRVhfv+Z2n7DMYjJ0BN+FSnYqjhIhXh2B7UENLiwtzuorW0qHBq39hSWkw4NxCwkhYRlop6LKSzhaVDPG3pLGGteFZTOllYO3jXkk4Sthqp0JBmC1sPy0hLs4TrWf8/s3Xa8aykdNYKgF0GhsF713ARpU20VgAcZGopC1DWsUl5DtFN+psYjUY/VOAtjq1l99TNe0K7N7RhVcIjTYp/BC3OfdmS4ziO4ziOo8UvKYcOybuuCb4AAAAASUVORK5CYII=) no-repeat;
    background-size: contain;
  }
}

.head{
  padding-bottom: .16rem;
  text-align: center;
  font-size: .34rem;
  font-weight: 500;
  font-family: "PingFang SC";
  color: #111;
}



</style>